"use client";

import {
  useLayoutEffect,
  type Dispatch,
  type MutableRefObject,
  type RefObject,
  type SetStateAction,
} from "react";
import type { MotionValue } from "framer-motion";

interface UseCarouselInitialPositionInput {
  containerRef: RefObject<HTMLDivElement | null>;
  initialDoubledIndex: number;
  lastReportedTeamIdRef: MutableRefObject<string | null>;
  originalLength: number;
  pitch: number;
  reportSnap: (doubledIndex: number) => void;
  scrollX: MotionValue<number>;
  setCenteredDoubledIndex: Dispatch<SetStateAction<number>>;
}

export function useCarouselInitialPosition({
  containerRef,
  initialDoubledIndex,
  lastReportedTeamIdRef,
  originalLength,
  pitch,
  reportSnap,
  scrollX,
  setCenteredDoubledIndex,
}: UseCarouselInitialPositionInput): void {
  useLayoutEffect(() => {
    const scrollElement = containerRef.current;
    if (!scrollElement || originalLength < 1) return;

    scrollElement.scrollLeft = initialDoubledIndex * pitch;
    scrollX.set(scrollElement.scrollLeft);
    setCenteredDoubledIndex(initialDoubledIndex);
    lastReportedTeamIdRef.current = null;
    reportSnap(initialDoubledIndex);
  }, [
    containerRef,
    initialDoubledIndex,
    lastReportedTeamIdRef,
    originalLength,
    pitch,
    reportSnap,
    scrollX,
    setCenteredDoubledIndex,
  ]);
}
